import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';

import LogoutMenu from '../logout/LogoutMenu';
import logo from '../../assets/images/CentelonLogo.png';

const Header = () => {
  const location = useLocation();
  const [hideLogout, setHideLogout] = useState(() => false);
  const noLogoutPaths = [
    '/login',
    '/thank-you',
    '/password-reset',
    '/account-recovery',
  ];
  useEffect(() => {
    setTimeout(() => {
      if (noLogoutPaths.includes(location.pathname)) setHideLogout(true);
      else setHideLogout(false);
    }, 200);
  }, [location.pathname]);

  return (
    <Box
      p={2}
      sx={{ pb: '2rem' }}
      display='flex'
      justifyContent='space-between'
      style={{
        background:
          'linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%)',
      }}
    >
      <img src={logo} alt='Centelon Solutions' />

      {!hideLogout ? <LogoutMenu /> : null}
    </Box>
  );
};

export default Header;
